<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Giới thiệu chung
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="2">
              <el-form-item class="mb-0" label="Ảnh">
                <el-upload
                  action
                  multiple
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.dataFormOther.fileUploadOption.AnhGioiThieu.limit"
                  :accept="mData.dataFormOther.fileUploadOption.AnhGioiThieu.accept"
                  :on-change="fn_uploadChangeAnhGioiThieu"
                  :on-preview="fn_uploadPreviewAnhGioiThieu"
                  :on-remove="fn_uploadRemoveAnhGioiThieu"
                  :on-exceed="fn_uploadExceedAnhGioiThieu"
                  :file-list="mData.dataFormOther.fileUploadOption.AnhGioiThieu.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[mData.dataFormOther.fileUploadOption.AnhGioiThieu.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.dataFormOther.fileUploadOption.AnhGioiThieu.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="mData.dataFormOther.fileUploadOption.AnhGioiThieu.dialogImageUrl"
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="10">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <CknoimgComponent
                  v-model="mData.dataForm.tieu_de"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('tieu_de')"
                ></CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Ngôn ngữ" prop="ngon_ngu">
                <el-select
                  v-model="mData.dataForm.ngon_ngu"
                  :placeholder="aLang.c_select"
                  :disabled="true"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNgonNgu"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12" class="mt-4">
              <b-card>
                <div slot="header">
                  Nội dung
                  <div class="card-header-actions"></div>
                </div>
                <b-row v-for="(item, index) in mData.dataForm.noi_dung" :key="index">
                  <b-col md="2">
                    <el-form-item class="mb-0" label="Ảnh">
                      <el-upload
                        action
                        multiple
                        :auto-upload="false"
                        list-type="picture-card"
                        :limit="mData.dataFormOther.fileUploadOption.AnhIconGioiThieu.limit"
                        :accept="mData.dataFormOther.fileUploadOption.AnhIconGioiThieu.accept"
                        :on-change="(file, fileList) => fn_uploadChangeAnhIconGioiThieu(file, fileList, index)"
                        :on-preview="fn_uploadPreviewAnhIconGioiThieu"
                        :on-remove="(file, fileList) => fn_uploadRemoveAnhIconGioiThieu(file, fileList, index)"
                        :on-exceed="fn_uploadExceedAnhIconGioiThieu"
                        :file-list="item.img"
                        :class="[item.img.length > 0 ? 'hidden-icon-upload' : '']"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <el-dialog
                        :close-on-click-modal="true"
                        :visible.sync="mData.dataFormOther.fileUploadOption.AnhIconGioiThieu.dialogVisible"
                        width="30%"
                        top="51px"
                        title="Chi tiết"
                      >
                        <img
                          width="100%"
                          :src="mData.dataFormOther.fileUploadOption.AnhIconGioiThieu.dialogImageUrl"
                          alt
                        />
                      </el-dialog>
                    </el-form-item>
                  </b-col>
                  <b-col md="9">
                    <el-form-item label="Nội dung">
                      <CknoimgComponent
                        v-model="item.noi_dung"
                      ></CknoimgComponent>
                    </el-form-item>
                  </b-col>
                  <b-col md="1">
                    <el-button
                      @click="removeRow(index)"
                      class="btn-remove-row"
                      :disabled="mData.viewMode == 'detail'"
                    >
                      <i class="icon-trash icons"></i>
                    </el-button>
                  </b-col>
                </b-row>
                <el-button
                  @click="addRow"
                  class="btn-add-row mt-4"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <i class="icon-plus icons"></i>
                </el-button>
              </b-card>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm()"
              v-ladda
            >{{aLang.c_update}}</el-button>
            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import DataService from '../../../service/DataService';
import GioiThieuModel from './GioiThieuModel';
import CknoimgComponent from "../../../component/CknoimgComponent";
import GioiThieuApi from '../../../moduleApi/GioiThieuApi';
import ExtensionService from '../../../service/ExtensionService';
export default {
  name: 'GioiThieu',
  components: {
    CknoimgComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "GioiThieu",
        viewMode: "create",
        dataForm: MethodService.copyObject(GioiThieuModel.dataForm),
        dataFormOther: MethodService.copyObject(GioiThieuModel.dataFormOther),
        dataDefault: {
          listNgonNgu: DataService.Languages
        }
      }
    }
  },
  async created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      await this.fn_getData(this.$router.currentRoute.params.id);
    }
    if (this.$router.currentRoute.query.lang) {
      this.mData.dataForm.ngon_ngu = this.$router.currentRoute.query.lang;
    }
  },
  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          data.noi_dung = data.noi_dung.filter(x => x.noi_dung);
          if (this.mData.viewMode === "update") {
            await GioiThieuApi.update(data);
          } else {
            await GioiThieuApi.create(data);
          }
          this.fn_go();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    async fn_getData(id) {
      let gioi_thieu = await GioiThieuApi.findById(id);
      if (gioi_thieu.result) {
        let dataChung = {
          id: gioi_thieu.result.anh_hien_thi,
          name: gioi_thieu.result.anh_hien_thi,
          url: ExtensionService.urlImg + gioi_thieu.result.anh_hien_thi
        };
        this.mData.dataFormOther.fileUploadOption.AnhGioiThieu.fileList.push(dataChung);
        this.mData.dataForm = gioi_thieu.result;
        this.mData.dataForm.noi_dung.forEach(item => {
          if (!item) return
          let data = item;
          data.img = [{
            id: item.id,
            name: item.id,
            url: ExtensionService.urlImg + item.id
          }];
        })
      }
    },

    addRow() {
      this.mData.dataForm.noi_dung.push(MethodService.copyObject(GioiThieuModel.dataFormNoiDung));
    },
    removeRow(idx) {
      this.mData.dataForm.noi_dung.splice(idx, 1);
    },

    // ảnh giới thiệu
    fn_uploadRemoveAnhGioiThieu() {
      this.mData.dataForm.anh_hien_thi = null;
      this.mData.dataFormOther.fileUploadOption.AnhGioiThieu.fileList = [];
    },
    fn_uploadChangeAnhGioiThieu(file, fileList) {
      ExtensionService.upload(file, "gioiThieu")
        .then(res => {
          this.mData.dataForm.anh_hien_thi = res.result;
          this.mData.dataFormOther.fileUploadOption.AnhGioiThieu.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhGioiThieu() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.dataFormOther.fileUploadOption.AnhGioiThieu.limit} file`
      );
    },
    fn_uploadPreviewAnhGioiThieu(file) {
      this.mData.dataFormOther.fileUploadOption.AnhGioiThieu.dialogImageUrl = file.url;
      this.mData.dataFormOther.fileUploadOption.AnhGioiThieu.dialogVisible = true;
    },

    // ảnh icon giới thiệu
    fn_uploadRemoveAnhIconGioiThieu(file, fileList, index) {
      this.mData.dataForm.noi_dung[index].img = [];
      this.$forceUpdate();
    },
    fn_uploadChangeAnhIconGioiThieu(file, fileList, index) {
      ExtensionService.upload(file, "gioiThieu")
        .then(res => {
          this.mData.dataForm.noi_dung[index].id = res.result;
          this.mData.dataForm.noi_dung[index].img = fileList;
          this.$forceUpdate();
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhIconGioiThieu() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.dataFormOther.fileUploadOption.AnhIconGioiThieu.limit} file`
      );
    },
    fn_uploadPreviewAnhIconGioiThieu(file) {
      this.mData.dataFormOther.fileUploadOption.AnhIconGioiThieu.dialogImageUrl = file.url;
      this.mData.dataFormOther.fileUploadOption.AnhIconGioiThieu.dialogVisible = true;
    },

    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },

    fn_go() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
.btn-add-row {
  width: 100%;
  font-size: 2rem;
  border-style: dashed;
  padding: 15px;
}
.btn-remove-row {
  margin-top: 32px;
}
</style>
